/*
 * classie
 * http://github.amexpub.com/modules/classie
 *
 * Copyright (c) 2013 AmexPub. All rights reserved.
 */

module.exports = require('./lib/classie');



/*****************
 ** WEBPACK FOOTER
 ** /Users/msolazzi/works/menichetti/~/classie/index.js
 ** module id = 130
 ** module chunks = 0
 **/